var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortFolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_10096",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3021 0V33.4584H0.84375V0H34.3021V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_10096)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5278 33.447C7.6085 33.1463 1.15571 26.6935 0.855054 18.7746C0.53035 10.2208 7.23958 3.15729 15.6601 2.90668C15.9139 2.89922 16.1233 3.10529 16.1255 3.35912C16.1535 6.40171 16.392 18.1791 16.392 18.1791H30.9367C31.1925 18.1791 31.4031 18.3894 31.3953 18.6449C31.1434 27.0641 24.0803 33.772 15.5278 33.447V33.447Z",
    fill: "#9CA1B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2261 13.3194C28.6316 13.3324 23.6785 13.3714 20.9512 13.3945C20.9616 10.6051 20.9798 5.55868 20.986 2.07764C23.8065 2.49107 26.4227 3.79963 28.4632 5.84016C30.5041 7.88101 31.813 10.4981 32.2261 13.3194V13.3194ZM18.9941 14.7776C18.9928 15.0988 19.2509 15.3565 19.5711 15.3565C21.7387 15.3377 29.4168 15.2727 33.6575 15.2658C34.0264 15.2652 34.3173 14.9561 34.3013 14.5875C33.9565 6.68835 27.585 0.345098 19.6858 0.000244141C19.3302 0.000244141 19.0367 0.286591 19.0364 0.645742C19.0331 4.63416 19.0029 12.5671 18.9941 14.7776V14.7776Z",
    fill: "#9CA1B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortFolio);
export default __webpack_public_path__ + "static/media/portFolio.978e75a3c752a759609d2928fa418b4b.svg";
export { ForwardRef as ReactComponent };